import OrderList from "@/components/order/list/List";
import OrderEdit from "@/components/order/edit/Edit";

export const order = [
    {path: '/order-list', name: 'order', component: OrderList},
    {path: '/order-edit/:id', name: 'orderEdit', component: OrderEdit},
]